"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProvinceUSA = exports.isProvinceCAN = void 0;
const enums_1 = require("../models/enums");
const isProvinceCAN = (province) => !!province && province in enums_1.CANProvinces;
exports.isProvinceCAN = isProvinceCAN;
const isProvinceUSA = (province) => !!province && province in enums_1.USAStates;
exports.isProvinceUSA = isProvinceUSA;
//# sourceMappingURL=country.js.map